import { create } from "zustand";

interface ConciergePendingQueryState {
  pendingQuery: string | null;
  pendingStacklineSku: string | null;
  setPendingQuery: (query: string, stacklineSku: string | null) => void;
  clearPendingQuery: () => void;
}

export const useConciergePendingQuery = create<ConciergePendingQueryState>(
  (set) => ({
    pendingQuery: null,
    pendingStacklineSku: null,
    setPendingQuery: (query: string, stacklineSku: string | null) =>
      set({ pendingQuery: query, pendingStacklineSku: stacklineSku }),
    clearPendingQuery: () =>
      set({ pendingQuery: null, pendingStacklineSku: null }),
  })
);

